import { StarRatings } from './components/star-ratings';
import { AddRatingForm } from './components/add-rating-form';

/**
 * Initialize functionality when DOM is ready
 */
jQuery( () => {
	const starRatingsElements = document.querySelectorAll( '.js-qala-ratings' );
	starRatingsElements.forEach( starRatingElement => {
		const instance = new StarRatings( starRatingElement );
		instance.init();
	} );

	const addRatingFormElements = document.querySelectorAll( '.js-qala-ratings-add-rating-form' );
	addRatingFormElements.forEach( formElement => {
		const instance = new AddRatingForm( formElement );
		instance.init();
	} );
} );
